import { api } from '@goaltree/backend/convex/_generated/api'
import type { Id } from '@goaltree/backend/convex/_generated/dataModel'
import { useMutation } from 'convex/react'

import { insertTempTreeNode } from '@/lib/goals-optimistic'
import { playCreatedSound } from '@/lib/sounds'

type AddNodeArgs = {
  parentId: Id<'nodes'>
  type: 'milestone' | 'target' | 'task'
  title: string
  category: string
}

export function useAddNode() {
  const create = useMutation(api.nodes.create).withOptimisticUpdate((store, args) => {
    if (args.parentId) insertTempTreeNode(store, { ...args, parentId: args.parentId })
  })
  return ({ parentId, type, title, category }: AddNodeArgs) => {
    playCreatedSound()
    return create({ parentId, type, title, category, effort: 'medium', aiGenerated: false })
  }
}
